// extracted by mini-css-extract-plugin
export default {"details_tab_main":"style_details_tab_main__rJnoy","tabs_top_container":"style_tabs_top_container__Wa8XC","tabs":"style_tabs__awSOR","active":"style_active__JZHC1"};